import { render, staticRenderFns } from "./AUploadFile.vue?vue&type=template&id=3104fa7c&scoped=true&"
import script from "./AUploadFile.vue?vue&type=script&lang=js&"
export * from "./AUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./AUploadFile.vue?vue&type=style&index=0&id=3104fa7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3104fa7c",
  null
  
)

export default component.exports